export default "__VITE_ASSET__CVIs$3os__"